import React from "react";

export const HeaderCard = ({ icon, title, subTitle }) => {
  return (
    <div className="d-flex align-items-center header-card">
      {icon ? <div className="icon">{icon}</div> : null}
      <div className="d-flex flex-column justify-content-between ">
        <span className="heading-xs title">{title}</span>
        <span className="heading-smb sub-title">{subTitle}</span>
      </div>
    </div>
  );
};
